import { render, staticRenderFns } from "./YzDataTableSorter.vue?vue&type=template&id=27bef5be&scoped=true&lang=pug&"
import script from "./YzDataTableSorter.vue?vue&type=script&lang=js&"
export * from "./YzDataTableSorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bef5be",
  null
  
)

export default component.exports